import { Flex } from '@radix-ui/themes';

export function Loading() {
  return (
    <Flex justify="center" align="center" height="100svh" width="100svw" style={{ backgroundColor: 'var(--gray-2)' }}>
      Loading...
    </Flex>
  );
}
